import type { FetchHrefLangsResponse } from '@rover/types';

export default function fetchHrefLangsResponseFactory(
  opts?: Partial<FetchHrefLangsResponse>
): FetchHrefLangsResponse {
  return {
    results: [],
    ...opts,
  };
}
